module.exports = __webpack_public_path__ + "img/IMG_5316-14286.ab5c3702.jpg";